<template>
  <g>
    <path
      d="M2 17.0002V20.0002H4V16.0002H3C2.45 16.0002 2 16.4502 2 17.0002Z"
    />
    <path
      d="M9 16.0002H5V20.0002L9.69 19.9902C10.07 19.9902 10.41 19.7802 10.58 19.4402L11.45 17.5402L9.86 14.0602L9 16.0002Z"
    />
    <path
      d="M21.71 16.2902C21.53 16.1102 21.28 16.0002 21 16.0002H20V20.0002H22V17.0002C22 16.7202 21.89 16.4702 21.71 16.2902Z"
    />
    <path
      d="M13.6 12.8402L17.65 4.00024H14.3L12.54 7.97024L12.05 9.07024L12 9.21024L9.70001 4.00024H6.35001L10.4 12.8402L11.92 16.1602L12 16.3402L13.42 19.4402C13.59 19.7802 13.93 19.9902 14.31 19.9902L19 20.0002V16.0002H15L13.6 12.8402Z"
    />
  </g>
</template>
